(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function nextFrame(callback) {
    if (typeof window.requestAnimationFrame === "function") {
      return window.requestAnimationFrame(callback);
    }

    return window.setTimeout(callback, 16);
  }

  function initHeader() {
    var header = document.querySelector("[data-lowkey-header]");
    if (!header) return;

    var desktopNav = header.querySelector("[data-lowkey-desktop-nav]");
    var menuTriggers = Array.prototype.slice.call(header.querySelectorAll("[data-lowkey-menu-trigger]"));
    var menuPanels = Array.prototype.slice.call(header.querySelectorAll("[data-lowkey-menu-panel]"));
    var navItems = Array.prototype.slice.call(header.querySelectorAll(".lowkey-header__nav-link"));
    var directLinks = Array.prototype.slice.call(header.querySelectorAll(".lowkey-header__nav-list > a"));
    var menuButton = header.querySelector("[data-lowkey-menu-toggle]");
    var drawer = header.querySelector("[data-lowkey-mobile-drawer]");
    var drawerDialog = header.querySelector("[data-lowkey-mobile-dialog]");
    var screens = Array.prototype.slice.call(header.querySelectorAll("[data-lowkey-mobile-screen]"));
    var lastDrawerTrigger = null;
    var pinnedMenuKey = null;

    function closeDesktopMenus(restoreFocus) {
      var openTrigger = null;
      menuTriggers.forEach(function (trigger) {
        if (trigger.getAttribute("aria-expanded") === "true") openTrigger = trigger;
      });
      if (restoreFocus === true && openTrigger && menuPanels.some(function (panel) { return panel.contains(document.activeElement); })) {
        openTrigger.focus();
      }
      pinnedMenuKey = null;
      menuTriggers.forEach(function (trigger) { trigger.setAttribute("aria-expanded", "false"); });
      menuPanels.forEach(function (panel) { panel.hidden = true; });
    }

    function getPanelLinks(key) {
      var panel = header.querySelector('[data-lowkey-menu-panel="' + key + '"]');
      return panel ? Array.prototype.slice.call(panel.querySelectorAll("a[href]")) : [];
    }

    function openDesktopMenu(key, pinned) {
      closeDesktopMenus();
      var trigger = header.querySelector('[data-lowkey-menu-trigger="' + key + '"]');
      var panel = header.querySelector('[data-lowkey-menu-panel="' + key + '"]');
      if (!trigger || !panel) return;
      pinnedMenuKey = pinned ? key : null;
      trigger.setAttribute("aria-expanded", "true");
      panel.hidden = false;
    }

    menuTriggers.forEach(function (trigger) {
      var key = trigger.getAttribute("data-lowkey-menu-trigger");
      trigger.addEventListener("pointerenter", function (event) {
        if (event.pointerType !== "mouse") return;
        openDesktopMenu(key, false);
      });
      trigger.addEventListener("focus", function () { openDesktopMenu(key, false); });
      trigger.addEventListener("click", function () {
        if (pinnedMenuKey === key) closeDesktopMenus();
        else openDesktopMenu(key, true);
      });
      trigger.addEventListener("keydown", function (event) {
        if (event.key !== "Tab" || event.shiftKey || trigger.getAttribute("aria-expanded") !== "true") return;
        var panelLinks = getPanelLinks(key);
        if (!panelLinks.length) return;
        event.preventDefault();
        panelLinks[0].focus();
      });
    });

    menuPanels.forEach(function (panel) {
      var key = panel.getAttribute("data-lowkey-menu-panel");
      panel.addEventListener("keydown", function (event) {
        if (event.key !== "Tab") return;
        var panelLinks = getPanelLinks(key);
        var trigger = header.querySelector('[data-lowkey-menu-trigger="' + key + '"]');
        if (!trigger || !panelLinks.length) return;
        if (event.shiftKey && document.activeElement === panelLinks[0]) {
          event.preventDefault();
          trigger.focus();
          return;
        }
        if (!event.shiftKey && document.activeElement === panelLinks[panelLinks.length - 1]) {
          var nextItem = navItems[navItems.indexOf(trigger) + 1];
          if (!nextItem) return;
          event.preventDefault();
          nextItem.focus();
        }
      });
    });

    directLinks.forEach(function (link) {
      link.addEventListener("pointerenter", closeDesktopMenus);
      link.addEventListener("focus", closeDesktopMenus);
    });

    if (desktopNav) {
      desktopNav.addEventListener("pointerleave", function (event) {
        if (event.pointerType !== "mouse" || pinnedMenuKey) return;
        if (!desktopNav.contains(document.activeElement)) closeDesktopMenus();
      });
      desktopNav.addEventListener("focusout", function (event) {
        if (!desktopNav.contains(event.relatedTarget)) closeDesktopMenus();
      });
    }

    function showScreen(id, focusFirst) {
      screens.forEach(function (screen) {
        var active = screen.getAttribute("data-lowkey-mobile-screen") === id;
        screen.hidden = !active;
        screen.classList.toggle("is-active", active);
        if (active && focusFirst) {
          var focusTarget = screen.querySelector("button, a[href]");
          if (focusTarget) focusTarget.focus();
        }
      });
    }

    function openDrawer() {
      if (!drawer || !menuButton) return;
      lastDrawerTrigger = menuButton;
      drawer.hidden = false;
      document.body.classList.add("lowkey-overlay-open");
      menuButton.setAttribute("aria-expanded", "true");
      showScreen("main", true);
    }

    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true;
      document.body.classList.remove("lowkey-overlay-open");
      if (menuButton) menuButton.setAttribute("aria-expanded", "false");
      if (lastDrawerTrigger) lastDrawerTrigger.focus();
    }

    if (menuButton) menuButton.addEventListener("click", openDrawer);
    header.querySelectorAll("[data-lowkey-drawer-close]").forEach(function (button) {
      button.addEventListener("click", closeDrawer);
    });
    header.querySelectorAll("[data-lowkey-screen-target]").forEach(function (button) {
      button.addEventListener("click", function () {
        showScreen(button.getAttribute("data-lowkey-screen-target"), true);
      });
    });
    header.querySelectorAll("[data-lowkey-screen-back]").forEach(function (button) {
      button.addEventListener("click", function () {
        showScreen(button.getAttribute("data-lowkey-screen-back"), true);
      });
    });

    if (drawerDialog) {
      drawerDialog.addEventListener("keydown", function (event) {
        if (event.key !== "Tab") return;
        var active = drawerDialog.querySelector("[data-lowkey-mobile-screen]:not([hidden])");
        var focusable = active ? Array.prototype.slice.call(active.querySelectorAll("button:not([disabled]), a[href]")) : [];
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (drawer && !drawer.hidden) closeDrawer();
      else closeDesktopMenus(true);
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth >= 1100) closeDrawer();
      else closeDesktopMenus();
    });
  }

  function initMotion() {
    if (prefersReducedMotion()) {
      document.documentElement.classList.add("lowkey-reduced-motion");
      document.querySelectorAll(".lowkey-reveal").forEach(function (element) {
        element.classList.add("is-visible");
      });
      return;
    }

    document.documentElement.classList.add("lowkey-motion-ready");

    var revealSelectors = [
      ".lowkey-reveal",
      ".lowkey-section-heading",
      ".lowkey-page-hero__content",
      ".lowkey-feature-card",
      ".lowkey-drop-card",
      ".lowkey-drops-showcase__lead",
      ".lowkey-meta-panel",
      ".lowkey-product-page__media",
      ".lowkey-product-page__info",
      ".lowkey-cart-item",
      ".lowkey-cart-summary",
      ".lowkey-empty",
      ".lowkey-contact-card",
      ".lowkey-resource-card",
      ".lowkey-collection-card",
      ".lowkey-blog-card"
    ];

    var revealItems = Array.prototype.slice.call(document.querySelectorAll(revealSelectors.join(",")));

    revealItems.forEach(function (element, index) {
      element.classList.add("lowkey-reveal");
      element.classList.add("lowkey-will-reveal");
      element.style.setProperty("--lowkey-reveal-delay", Math.min(index % 6, 5) * 70 + "ms");
    });

    var ticking = false;

    function syncReveal() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      revealItems.forEach(function (element) {
        if (element.classList.contains("is-visible")) return;

        var rect = element.getBoundingClientRect();
        if (rect.top < viewportHeight * 0.88 && rect.bottom > -80) {
          element.classList.add("is-visible");
        }
      });

      ticking = false;
    }

    function requestRevealSync() {
      if (ticking) return;
      ticking = true;
      nextFrame(syncReveal);
    }

    syncReveal();
    nextFrame(syncReveal);
    window.addEventListener("scroll", requestRevealSync, { passive: true });
    window.addEventListener("resize", requestRevealSync);
    window.addEventListener("pageshow", requestRevealSync);
    setTimeout(requestRevealSync, 250);
  }

  function initHeroMotion() {
    if (prefersReducedMotion()) return;

    var hero = document.querySelector(".lowkey-hero");
    if (!hero) return;

    var ticking = false;

    function syncHero() {
      var rect = hero.getBoundingClientRect();
      var progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)));
      hero.style.setProperty("--lowkey-hero-y", (progress * 34).toFixed(2) + "px");
      ticking = false;
    }

    function requestSync() {
      if (ticking) return;
      ticking = true;
      nextFrame(syncHero);
    }

    syncHero();
    window.addEventListener("scroll", requestSync, { passive: true });
    window.addEventListener("resize", requestSync);
  }

  // ponytail: one global queue is enough while the theme owns a single cart drawer.
  var cartMutationQueue = Promise.resolve();

  function enqueueCartMutation(callback) {
    var mutation = cartMutationQueue.then(callback);
    cartMutationQueue = mutation.catch(function () {});
    return mutation;
  }

  function nextCartQuantity(quantity, min, max, increment, action) {
    if (action === "remove") return 0;
    var next = action === "increase" ? quantity + increment : quantity - increment;
    next = Math.max(min, next);
    return max === null ? next : Math.min(max, next);
  }

  function getCartLineCorrection(quantity, max) {
    if (max === null || quantity <= max) return null;
    return Math.max(0, max);
  }

  function normalizeCartLineMax(rawMax, min, increment) {
    if (rawMax > 0 && rawMax < min) return 0;
    if (rawMax < min) return rawMax;
    return rawMax - ((rawMax - min) % increment);
  }

  function getCartInventoryMaxes(lines) {
    var quantitiesByVariant = {};
    lines.forEach(function (line) {
      quantitiesByVariant[line.variantId] = (quantitiesByVariant[line.variantId] || 0) + line.quantity;
    });
    return lines.map(function (line) {
      var otherLineQuantity = quantitiesByVariant[line.variantId] - line.quantity;
      var rawMax = line.inventory === null ? null : line.inventory - otherLineQuantity;
      if (line.ruleMax !== null) {
        var ruleLineMax = line.ruleMax - otherLineQuantity;
        rawMax = rawMax === null ? ruleLineMax : Math.min(rawMax, ruleLineMax);
      }
      return rawMax === null ? null : normalizeCartLineMax(rawMax, line.min, line.increment);
    });
  }

  function getCartPageQuantityState(value, min, max) {
    var hasMax = typeof max === "number" && Number.isFinite(max);
    var atMax = hasMax && value >= max;
    return {
      decreaseDisabled: value <= min,
      increaseDisabled: atMax,
      showMax: atMax
    };
  }

  function updateCartPageQuantityControls(form) {
    form.querySelectorAll("[data-lowkey-cart-page-quantity]").forEach(function (group) {
      var input = group.querySelector('input[name="updates[]"]');
      if (!input) return;

      var maxValue = parseInt(input.max, 10);
      var state = getCartPageQuantityState(
        parseInt(input.value, 10) || 0,
        parseInt(input.min, 10) || 1,
        input.max === "" || Number.isNaN(maxValue) ? null : maxValue
      );
      var decrease = group.querySelector('[data-lowkey-cart-page-quantity-action="decrease"]');
      var increase = group.querySelector('[data-lowkey-cart-page-quantity-action="increase"]');
      var maxStatus = group.querySelector("[data-lowkey-cart-page-max-status]");

      if (decrease) decrease.disabled = state.decreaseDisabled;
      if (increase) increase.disabled = state.increaseDisabled;
      if (maxStatus) maxStatus.hidden = !state.showMax;
    });
  }

  function adjustCartPageQuantity(form, button) {
    if (!button || button.disabled || typeof button.closest !== "function" || typeof button.getAttribute !== "function") return false;

    var inputId = button.getAttribute("aria-controls");
    var group = button.closest("[data-lowkey-cart-page-quantity]");
    var input = group && group.querySelector('input[name="updates[]"]');
    var action = button.getAttribute("data-lowkey-cart-page-quantity-action");
    var stepMethod = action === "decrease" ? "stepDown" : action === "increase" ? "stepUp" : null;
    if (
      !inputId ||
      !input ||
      input.id !== inputId ||
      input.type !== "number" ||
      !stepMethod ||
      typeof input[stepMethod] !== "function" ||
      typeof input.dispatchEvent !== "function"
    ) return false;

    input[stepMethod]();
    input.dispatchEvent(new Event("input", { bubbles: true }));
    return true;
  }

  function updateCartPageInventoryLimits(form) {
    var inputs = Array.prototype.slice.call(form.querySelectorAll("[data-lowkey-cart-variant-id]"));
    var lines = inputs.map(function (input) {
      var inventoryMax = input.getAttribute("data-lowkey-cart-inventory-max");
      var ruleMax = input.getAttribute("data-lowkey-cart-rule-max");
      return {
        variantId: input.getAttribute("data-lowkey-cart-variant-id"),
        quantity: parseInt(input.value, 10) || 0,
        inventory: inventoryMax === "" || inventoryMax === null ? null : parseInt(inventoryMax, 10),
        min: parseInt(input.min, 10) || 1,
        increment: parseInt(input.step, 10) || 1,
        ruleMax: ruleMax === "" ? null : parseInt(ruleMax, 10)
      };
    });
    getCartInventoryMaxes(lines).forEach(function (max, index) {
      if (max === null) inputs[index].removeAttribute("max");
      else inputs[index].max = max;
    });
    updateCartPageQuantityControls(form);
  }

  function initCartPageInventoryLimits() {
    var form = document.querySelector("#LowkeyCartForm");
    if (!form) return;

    updateCartPageInventoryLimits(form);
    form.addEventListener("click", function (event) {
      var button = event.target.closest && event.target.closest("[data-lowkey-cart-page-quantity-action]");
      if (button) adjustCartPageQuantity(form, button);
    });
    form.addEventListener("input", function () {
      updateCartPageInventoryLimits(form);
    });
    form.addEventListener("submit", function (event) {
      updateCartPageInventoryLimits(form);
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
      }
    });
  }

  function resolveCartFocus(lineKeys, state) {
    if (!lineKeys.length) return null;
    if (lineKeys.indexOf(state.lineKey) !== -1) {
      return { lineKey: state.lineKey, action: state.action };
    }
    return {
      lineKey: lineKeys[Math.min(state.ordinal, lineKeys.length - 1)],
      action: "remove"
    };
  }

  function getCartSectionVariantQuantity(section, variantId) {
    if (!section || variantId === null || variantId === undefined) return null;
    var found = false;
    var total = 0;
    section.querySelectorAll("[data-lowkey-cart-item]").forEach(function (item) {
      if (item.getAttribute("data-variant-id") !== String(variantId)) return;
      found = true;
      total += parseInt(item.getAttribute("data-quantity"), 10) || 0;
    });
    return found ? total : null;
  }

  function setProductSubmitState(form, canAdd, fallbackButton) {
    var root = form.closest("[data-lowkey-product]");
    var submits = root ? root.querySelectorAll('button[type="submit"]') : fallbackButton ? [fallbackButton] : [];
    Array.prototype.forEach.call(submits, function (submit) { submit.disabled = !canAdd; });
  }

  function reconcileProductCartQuantity(form, variantId, cartQuantity) {
    if (!Number.isFinite(cartQuantity)) return;

    var variantSelect = form.querySelector("[data-lowkey-variant-select]");
    var selectedOption = variantSelect && variantSelect.selectedOptions && variantSelect.selectedOptions[0];
    var matchingOption = variantSelect && Array.prototype.find.call(variantSelect.options, function (option) {
      return String(option.value) === String(variantId);
    });
    if (matchingOption) matchingOption.setAttribute("data-cart-quantity", String(cartQuantity));
    if (variantSelect && (!selectedOption || String(selectedOption.value) !== String(variantId))) return;

    var quantity = form.querySelector("quantity-selector-component");
    if (!quantity || typeof quantity.setCartQuantity !== "function" || typeof quantity.canAddToCart !== "function") return;

    quantity.setCartQuantity(cartQuantity);
    var canAdd = (!selectedOption || selectedOption.getAttribute("data-available") !== "false") && quantity.canAddToCart().canAdd;
    setProductSubmitState(form, canAdd);
    return canAdd;
  }

  function initCartDrawer() {
    var root = document.querySelector("[data-lowkey-cart-drawer]");
    var cartLink = document.querySelector("[data-lowkey-cart-link]");
    if (!root || !cartLink) return;

    var dialog = root.querySelector("[data-lowkey-cart-dialog]");
    var sectionId = root.getAttribute("data-lowkey-cart-section-id");
    var itemsRoot = root.querySelector("[data-lowkey-cart-items]");
    var summaryRoot = root.querySelector("[data-lowkey-cart-summary]");
    var errorRoot = root.querySelector("[data-lowkey-cart-error]");
    var retryButton = root.querySelector("[data-lowkey-cart-retry]");
    var badgeRoot = document.querySelector("[data-lowkey-cart-badge]");
    var toastRoot = document.querySelector("[data-lowkey-cart-toast]");
    var toastImage = toastRoot && toastRoot.querySelector("[data-lowkey-cart-toast-image]");
    var toastMessage = toastRoot && toastRoot.querySelector("[data-lowkey-cart-toast-message]");
    var toastTitle = toastRoot && toastRoot.querySelector("[data-lowkey-cart-toast-title]");
    var toastClose = toastRoot && toastRoot.querySelector("[data-lowkey-cart-toast-close]");
    var toastView = toastRoot && toastRoot.querySelector("[data-lowkey-cart-toast-view]");
    var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    var lastCartTrigger = null;
    var toastTimer = null;
    var pendingLineKeys = new Set();

    if (routesRoot.slice(-1) !== "/") routesRoot += "/";

    function closeCartToast() {
      if (!toastRoot) return;
      if (toastTimer) window.clearTimeout(toastTimer);
      toastRoot.classList.remove("is-visible");
      window.setTimeout(function () {
        if (!toastRoot.classList.contains("is-visible")) {
          toastRoot.setAttribute("hidden", "");
        }
      }, 220);
    }

    function showCartToast(item, errorMessage, errorLabel, successMessage) {
      if (!toastRoot || !toastMessage || !toastTitle) return;

      var isError = Boolean(errorMessage);
      var image = successMessage ? null : (item && (item.image || (item.featured_image && item.featured_image.url))) || (toastImage && toastImage.src);

      if (toastTimer) window.clearTimeout(toastTimer);
      toastRoot.classList.toggle("is-error", isError);
      toastRoot.setAttribute("role", isError ? "alert" : "status");
      toastRoot.setAttribute("aria-live", isError ? "assertive" : "polite");
      toastMessage.textContent = isError ? (errorLabel || "Unable to add item") : (successMessage || "Added to cart");
      toastTitle.textContent = errorMessage || (item && (item.product_title || item.title)) || "";

      if (toastImage) {
        toastImage.hidden = !image || isError;
        if (image && !isError) toastImage.src = image;
      }
      if (toastView) toastView.hidden = isError;

      toastRoot.removeAttribute("hidden");
      nextFrame(function () {
        toastRoot.classList.add("is-visible");
      });
      toastTimer = window.setTimeout(closeCartToast, 4000);
    }

    function restoreCartFocus(state) {
      if (!state) return;

      var items = Array.prototype.slice.call(
        itemsRoot.querySelectorAll("[data-lowkey-cart-item]")
      );
      var lineKeys = items.map(function (item) {
        return item.getAttribute("data-line-key");
      });
      var targetState = resolveCartFocus(lineKeys, state);

      if (!targetState) {
        dialog.focus();
        return;
      }

      var targetItem = items.find(function (item) {
        return item.getAttribute("data-line-key") === targetState.lineKey;
      });
      var target = targetItem && targetItem.querySelector(
        '[data-lowkey-cart-action="' + targetState.action + '"]:not([disabled])'
      );
      if (!target && targetItem) {
        target = targetItem.querySelector("[data-lowkey-cart-action]:not([disabled])");
      }
      (target || dialog).focus();
    }

    function showCartError(focusState) {
      errorRoot.removeAttribute("hidden");
      restoreCartFocus(focusState);
    }

    function updateCartSection(sectionHtml, focusState) {
      var parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
      var nextItems = parsed.querySelector("[data-lowkey-cart-items]");
      var nextSummary = parsed.querySelector("[data-lowkey-cart-summary]");

      if (!nextItems || !nextSummary) {
        throw new Error("Unable to refresh cart.");
      }

      itemsRoot.innerHTML = nextItems.innerHTML;
      summaryRoot.innerHTML = nextSummary.innerHTML;

      var nextBadge = parsed.querySelector("[data-lowkey-cart-badge]");
      if (nextBadge && badgeRoot) {
        badgeRoot.textContent = nextBadge.textContent;
        badgeRoot.hidden = nextBadge.hidden;
      }

      errorRoot.setAttribute("hidden", "");
      restoreCartFocus(focusState);
      return parsed;
    }

    function refreshCartSection(focusState) {
      var url = new URL(window.location.href);
      url.searchParams.set("section_id", sectionId);
      root.classList.add("is-loading");

      return fetch(url.toString(), { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("Unable to refresh cart.");
          return response.text();
        })
        .then(function (sectionHtml) {
          return updateCartSection(sectionHtml, focusState);
        })
        .catch(function (error) {
          showCartError(focusState);
          showCartToast(null, error.message, "Unable to refresh cart");
          return null;
        })
        .finally(function () {
          root.classList.remove("is-loading");
        });
    }

    function applyCartSection(sectionHtml, focusState) {
      if (!sectionHtml) return refreshCartSection(focusState);
      try {
        return updateCartSection(sectionHtml, focusState);
      } catch (error) {
        return refreshCartSection(focusState);
      }
    }

    function correctNextOverLimitLine() {
      return enqueueCartMutation(function () {}).then(function () {
        var items = Array.prototype.slice.call(itemsRoot.querySelectorAll("[data-lowkey-cart-item]"));
        var correction = null;

        items.some(function (itemElement) {
          var key = itemElement.getAttribute("data-line-key");
          var quantity = parseInt(itemElement.getAttribute("data-quantity"), 10);
          var maxValue = parseInt(itemElement.getAttribute("data-max"), 10);
          var max = Number.isNaN(maxValue) ? null : maxValue;
          var correctedQuantity = getCartLineCorrection(quantity, max);

          if (!key || correctedQuantity === null) return false;
          correction = { key: key, quantity: correctedQuantity, itemElement: itemElement };
          return true;
        });

        if (!correction) return true;

        // ponytail: sequential correction preserves duplicate-line inventory; batch only if invalid multi-line carts become common.
        return changeCartItem(correction.key, correction.quantity, correction.itemElement).then(function (result) {
          if (result === null) return null;
          showCartToast(
            { title: "ONLY " + correction.quantity + " AVAILABLE" },
            null,
            null,
            "QUANTITY ADJUSTED"
          );
          return correctNextOverLimitLine();
        });
      });
    }

    function syncCartOnOpen() {
      return enqueueCartMutation(function () {
        return refreshCartSection();
      }).then(function (result) {
        if (result === null) return null;
        return correctNextOverLimitLine();
      });
    }

    function changeCartItem(key, quantity, itemElement, focusState) {
      pendingLineKeys.add(key);
      itemElement.classList.add("is-updating");
      itemElement.setAttribute("aria-busy", "true");

      return enqueueCartMutation(function () {
        return fetch(routesRoot + "cart/change.js", {
          method: "POST",
          body: JSON.stringify({
            id: key,
            quantity: quantity,
            sections: [sectionId],
            sections_url: window.location.pathname
          }),
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
          })
          .then(function (response) {
            return response.json().then(function (responseData) {
              if (!response.ok || responseData.status) {
                throw new Error(responseData.description || responseData.message || "Unable to update cart.");
              }
              return responseData;
            });
          })
          .then(function (responseData) {
            var sectionHtml = responseData.sections && responseData.sections[sectionId];
            return applyCartSection(sectionHtml, focusState);
          })
          .catch(function (error) {
            showCartError(focusState);
            showCartToast(null, error.message || "Unable to update cart.", "Unable to update cart");
            return null;
          });
      })
        .finally(function () {
          pendingLineKeys.delete(key);
          if (itemElement.isConnected) {
            itemElement.classList.remove("is-updating");
            itemElement.removeAttribute("aria-busy");
          }
        });
    }

    retryButton.addEventListener("click", function () {
      enqueueCartMutation(function () {
        return refreshCartSection();
      }).then(function (result) {
        if (result !== null && dialog) dialog.focus();
      });
    });

    function openDrawer() {
      lastCartTrigger = document.activeElement;
      root.removeAttribute("hidden");
      document.body.classList.add("lowkey-overlay-open");
      nextFrame(function () {
        root.classList.add("is-open");
        cartLink.setAttribute("aria-expanded", "true");
        if (dialog) dialog.focus();
      });
      syncCartOnOpen();
    }

    function closeDrawer() {
      root.classList.remove("is-open");
      document.body.classList.remove("lowkey-overlay-open");
      cartLink.setAttribute("aria-expanded", "false");
      if (lastCartTrigger && typeof lastCartTrigger.focus === "function") lastCartTrigger.focus();
      lastCartTrigger = null;
      window.setTimeout(function () {
        if (!root.classList.contains("is-open")) {
          root.setAttribute("hidden", "");
        }
      }, 260);
    }

    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form.matches || !form.matches("[data-lowkey-ajax-cart]")) return;

      event.preventDefault();
      var button = event.submitter || form.querySelector('[type="submit"]');
      if (form.getAttribute("aria-busy") === "true" || (button && button.disabled)) return;

      var formData = new FormData(form);
      var submittedVariantId = formData.get("id");
      formData.append("sections", sectionId);
      formData.append("sections_url", window.location.pathname);
      form.setAttribute("aria-busy", "true");
      if (button) button.disabled = true;

      enqueueCartMutation(function () {
        return fetch(routesRoot + "cart/add.js", {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: { Accept: "application/json" }
        })
          .then(function (response) {
            return response.json().then(function (responseData) {
              if (!response.ok || responseData.status) {
                throw new Error(responseData.description || responseData.message || "Unable to add this item.");
              }
              return responseData;
            });
          })
          .then(function (responseData) {
            var sectionHtml = responseData.sections && responseData.sections[sectionId];
            var sectionUpdate = applyCartSection(sectionHtml);

            return Promise.resolve(sectionUpdate).then(function (result) {
              if (result !== null) {
                var cartQuantity = getCartSectionVariantQuantity(result, submittedVariantId);
                reconcileProductCartQuantity(form, submittedVariantId, cartQuantity);
                showCartToast(responseData);
              }
            });
          });
      })
        .catch(function (error) {
          showCartToast(null, error.message || "Unable to add this item.");
        })
        .finally(function () {
          form.removeAttribute("aria-busy");
          var variantSelect = form.querySelector("[data-lowkey-variant-select]");
          var selectedOption = variantSelect && variantSelect.selectedOptions && variantSelect.selectedOptions[0];
          var quantity = form.querySelector("quantity-selector-component");
          var canAdd = selectedOption ? selectedOption.getAttribute("data-available") === "true" : true;
          if (quantity && typeof quantity.canAddToCart === "function") canAdd = canAdd && quantity.canAddToCart().canAdd;
          setProductSubmitState(form, canAdd, button);
        });
    });

    cartLink.addEventListener("click", function (event) {
      if (window.location.pathname.indexOf("/cart") === 0) return;
      event.preventDefault();
      openDrawer();
    });

    if (toastClose) toastClose.addEventListener("click", closeCartToast);
    if (toastView) {
      toastView.addEventListener("click", function () {
        closeCartToast();
        openDrawer();
      });
    }

    if (itemsRoot) {
      itemsRoot.addEventListener("click", function (event) {
        var button = event.target.closest("[data-lowkey-cart-action]");
        if (!button || button.disabled) return;

        var itemElement = button.closest("[data-lowkey-cart-item]");
        if (!itemElement || itemElement.classList.contains("is-updating")) return;

        var action = button.getAttribute("data-lowkey-cart-action");
        var key = itemElement.getAttribute("data-line-key");
        var quantity = parseInt(itemElement.getAttribute("data-quantity"), 10);
        if (!key || !quantity || pendingLineKeys.has(key)) return;

        var min = parseInt(itemElement.getAttribute("data-min"), 10) || 1;
        var maxValue = parseInt(itemElement.getAttribute("data-max"), 10);
        var max = Number.isNaN(maxValue) ? null : maxValue;
        var increment = parseInt(itemElement.getAttribute("data-increment"), 10) || 1;
        var ordinal = Array.prototype.indexOf.call(itemsRoot.querySelectorAll("[data-lowkey-cart-item]"), itemElement);
        var focusState = { lineKey: key, action: action, ordinal: ordinal };
        quantity = nextCartQuantity(quantity, min, max, increment, action);
        changeCartItem(key, quantity, itemElement, focusState);
      });
    }

    root.addEventListener("click", function (event) {
      if (event.target === root) closeDrawer();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("is-open")) {
        closeDrawer();
      }
    });

    if (dialog) {
      dialog.addEventListener("keydown", function (event) {
        if (event.key !== "Tab") return;
        var focusable = Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) {
          event.preventDefault();
          dialog.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      dialog.addEventListener("click", function (event) {
        if (event.target.closest("[data-lowkey-cart-close]")) closeDrawer();
        event.stopPropagation();
      });
    }
  }

  function initShelves() {
    document.querySelectorAll("[data-lowkey-shelf]").forEach(function (section) {
      var rail = section.querySelector("[data-lowkey-shelf-rail]");
      if (!rail) return;

      section.querySelectorAll("[data-lowkey-scroll]").forEach(function (button) {
        button.addEventListener("click", function () {
          var dir = button.getAttribute("data-lowkey-scroll") === "next" ? 1 : -1;
          rail.scrollBy({ left: dir * 360, behavior: "smooth" });
        });
      });
    });
  }

  function initBackgroundAudio() {
    var root = document.querySelector("[data-lowkey-audio-player]");
    if (!root) return;

    var audio = root.querySelector("[data-lowkey-audio]");
    var button = root.querySelector("[data-lowkey-audio-toggle]");
    var label = root.querySelector("[data-lowkey-audio-label]");

    if (!audio || !button) return;

    var storageKey = "lowkey.audio.state.v1";
    var storedState = null;
    var hasAudioState = false;

    audio.volume = 0.42;

    function readStoredState() {
      try {
        var value = window.sessionStorage.getItem(storageKey);
        if (!value) return null;
        var state = JSON.parse(value);
        if (!state || typeof state.time !== "number" || typeof state.playing !== "boolean") return null;
        return state;
      } catch (_error) {
        return null;
      }
    }

    function persistState(isPlaying) {
      var state = {
        time: Number.isFinite(audio.currentTime) ? audio.currentTime : 0,
        playing: isPlaying
      };
      storedState = state;
      hasAudioState = true;
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(state));
      } catch (_error) {
        // Storage can be unavailable in strict privacy modes.
      }
    }

    function setState(isPlaying) {
      var action = isPlaying ? "Pause background music" : "Play background music";
      root.classList.toggle("is-playing", isPlaying);
      button.setAttribute("aria-pressed", isPlaying ? "true" : "false");
      button.setAttribute("aria-label", action);
      button.setAttribute("title", action);
      if (label) label.textContent = action;
    }

    function playAudio() {
      var playPromise = audio.play();

      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(function () {
            setState(true);
            persistState(true);
          })
          .catch(function () {
            setState(false);
          });
      } else {
        setState(true);
        persistState(true);
      }
    }

    function pauseAudio() {
      audio.pause();
      setState(false);
      persistState(false);
    }

    function restoreStoredState() {
      if (!storedState) return;
      var position = storedState.time;
      if (Number.isFinite(audio.duration) && audio.duration > 0) position %= audio.duration;
      try {
        audio.currentTime = position;
      } catch (_error) {
        // Some browsers only allow seeking after metadata is ready.
      }
      if (storedState.playing) playAudio();
    }

    button.addEventListener("click", function () {
      if (audio.paused) {
        playAudio();
      } else {
        pauseAudio();
      }
    });

    audio.addEventListener("ended", function () {
      setState(false);
      persistState(false);
    });

    storedState = readStoredState();
    hasAudioState = Boolean(storedState);

    if (storedState) {
      if (audio.readyState >= 1) restoreStoredState();
      else audio.addEventListener("loadedmetadata", restoreStoredState, { once: true });
    }

    window.addEventListener("pagehide", function () {
      if (hasAudioState || !audio.paused) persistState(!audio.paused);
    });
  }

  function initSignupPopup() {
    var root = document.querySelector("[data-lowkey-signup-popup]");
    if (!root) return;

    var storageKey = "lowkey.signup.dismissed.v1";
    var dialog = root.querySelector("[data-lowkey-signup-dialog]");
    var success = root.querySelector("[data-lowkey-signup-success]");
    var errors = root.querySelector("[data-lowkey-signup-errors]");
    var previousFocus = null;

    function isRemembered() {
      try {
        return window.localStorage.getItem(storageKey) === "1";
      } catch (_error) {
        return false;
      }
    }

    function remember() {
      try {
        window.localStorage.setItem(storageKey, "1");
      } catch (_error) {
        // Storage can be unavailable in strict privacy modes.
      }
    }

    function focusableElements() {
      if (!dialog) return [];
      return Array.prototype.slice.call(dialog.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), a[href], select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return !element.matches('input[type="hidden"]') &&
          !element.closest('[hidden], [aria-hidden="true"], [inert]') &&
          element.getClientRects().length &&
          window.getComputedStyle(element).visibility !== "hidden";
      });
    }

    function openPopup() {
      previousFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add("lowkey-signup-open");
      window.requestAnimationFrame(function () {
        var target = root.querySelector('input[type="email"]') || dialog;
        if (target) target.focus();
      });
    }

    function closePopup() {
      remember();
      root.hidden = true;
      document.body.classList.remove("lowkey-signup-open");
      if (previousFocus && typeof previousFocus.focus === "function") previousFocus.focus();
    }

    if (!success && isRemembered()) return;

    root.querySelectorAll("[data-lowkey-signup-close]").forEach(function (button) {
      button.addEventListener("click", closePopup);
    });
    root.addEventListener("click", function (event) {
      if (event.target === root) closePopup();
    });
    root.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closePopup();
        return;
      }
      if (event.key !== "Tab") return;

      var focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        if (dialog) dialog.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.setTimeout(openPopup, success || errors ? 0 : 900);
  }

  function selectProductGalleryMedia(gallery, targetId) {
    var target = document.getElementById(targetId);
    if (!target || !gallery.contains(target) || !target.hasAttribute("data-lowkey-gallery-media")) return false;

    gallery.querySelectorAll("[data-lowkey-gallery-media]").forEach(function (item) {
      item.hidden = item !== target;
    });
    gallery.querySelectorAll("[data-lowkey-gallery-thumbnail]").forEach(function (thumbnail) {
      if (thumbnail.getAttribute("aria-controls") === targetId) thumbnail.setAttribute("aria-current", "true");
      else thumbnail.removeAttribute("aria-current");
    });
    return true;
  }

  function initProductGalleries() {
    document.querySelectorAll("[data-lowkey-product-gallery]").forEach(function (gallery) {
      if (gallery.getAttribute("data-lowkey-gallery-ready") === "true") return;
      var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll("[data-lowkey-gallery-thumbnail]"));
      var validThumbnail = function (thumbnail) {
        var targetId = thumbnail.getAttribute("aria-controls") || "";
        var target = document.getElementById(targetId);
        return target && gallery.contains(target) && target.hasAttribute("data-lowkey-gallery-media");
      };
      var initial = thumbnails.find(function (thumbnail) {
        return thumbnail.getAttribute("aria-current") === "true" && validThumbnail(thumbnail);
      }) || thumbnails.find(validThumbnail);

      thumbnails.forEach(function (thumbnail) {
        thumbnail.removeAttribute("aria-current");
      });
      if (!initial || !selectProductGalleryMedia(gallery, initial.getAttribute("aria-controls") || "")) return;

      gallery.addEventListener("click", function (event) {
        if (!(event.target instanceof Element)) return;
        var thumbnail = event.target.closest("[data-lowkey-gallery-thumbnail]");
        if (!thumbnail || !gallery.contains(thumbnail)) return;
        event.preventDefault();
        selectProductGalleryMedia(gallery, thumbnail.getAttribute("aria-controls") || "");
      });
      gallery.setAttribute("data-lowkey-gallery-ready", "true");
    });
  }

  function updateProductVariantState(select) {
    var root = select.closest("[data-lowkey-product]");
    var option = select.selectedOptions && select.selectedOptions[0];
    if (!root || !option) return;

    var price = root.querySelector("[data-lowkey-product-price]");
    var compare = root.querySelector("[data-lowkey-product-compare]");
    var stickyPrice = root.querySelector("[data-lowkey-product-sticky-price]");
    var submits = root.querySelectorAll('button[type="submit"]');
    var quantity = select.form && select.form.querySelector("quantity-selector-component");
    var formBusy = select.form && typeof select.form.getAttribute === "function" && select.form.getAttribute("aria-busy") === "true";
    var min = option.getAttribute("data-min") || "1";
    var max = option.getAttribute("data-max") || null;
    var increment = option.getAttribute("data-increment") || "1";
    var compareAt = option.getAttribute("data-compare-at") || "";
    var available = option.getAttribute("data-available") === "true";
    var canAdd = available;

    if (price) price.textContent = option.getAttribute("data-price") || "";
    if (stickyPrice) stickyPrice.textContent = option.getAttribute("data-price") || "";
    if (compare) {
      compare.textContent = compareAt;
      compare.hidden = !compareAt;
    }
    if (quantity && typeof quantity.setValue === "function" && typeof quantity.updateConstraints === "function") {
      var input = quantity.querySelector("input[name='quantity']");
      if (input) input.setAttribute("data-cart-quantity", option.getAttribute("data-cart-quantity") || "0");
      quantity.setValue(min);
      quantity.updateConstraints(min, max, increment);
      if (typeof quantity.setAvailability === "function") quantity.setAvailability(available);
      if (typeof quantity.canAddToCart === "function") canAdd = canAdd && quantity.canAddToCart().canAdd;
    }
    submits.forEach(function (submit) {
      submit.disabled = formBusy || !canAdd;
    });
  }

  function initProductVariantState() {
    document.querySelectorAll("[data-lowkey-variant-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        updateProductVariantState(select);
      });
    });
  }

  function initProductSticky() {
    var sticky = document.querySelector(".lowkey-product-page__sticky");
    var footer = document.querySelector(".lowkey-footer");
    if (!sticky || !footer || !window.IntersectionObserver) return;

    new window.IntersectionObserver(function (entries) {
      sticky.hidden = entries[0].isIntersecting;
    }).observe(footer);
  }

  function init() {
    initHeader();
    initMotion();
    initHeroMotion();
    initProductVariantState();
    initProductGalleries();
    initProductSticky();
    initCartDrawer();
    initCartPageInventoryLimits();
    initShelves();
    initBackgroundAudio();
    initSignupPopup();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
